import React from 'react'
import { observer } from 'mobx-react-lite'
import { useContactsPage } from 'app/components/contacts-page/useContactsPage'
import { ContactsPageComponent } from 'app/components/contacts-page/ContactsPageComponent'

export const ContactsSlugs = [`all`, `active-leads`, `scheduled-leads`, `closed-lost-leads`, `due-for-hygiene`] as const

export default observer(function Contacts(): React.ReactElement {
  const props = useContactsPage()
  return <ContactsPageComponent {...props} />
})
